module.exports = __webpack_public_path__ + "static/bass_en-27150eb5b9762dec5982ffbc50bce246.pdf";